import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";

import TextField from "@mui/material/TextField";

import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { InputAdornment } from "@mui/material";
import { useLocation } from "react-router-dom";
import { db, getDoc, doc } from "../../firebase";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://heslet.net/">
        Heslet LLC.
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function Login() {
  const { naver } = window;
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const location = useLocation();

  const [DBerror, setDBerror] = useState("");
  const [processing, setProcessing] = useState(false);

  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const {
    login,
    setFirstnameByFunction,
    setLastnameByFunction,
    setPhone,
    setCurrentUser,
    setStripeUserId,
  } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const submit = async (data) => {
    setProcessing(true);
    try {
      let uid;
      await login(data.email, data.password).then((response) => {
        setCurrentUser(response.user);
        console.log("response", response);
        uid = response.user.uid;
      });

      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);

      window.sessionStorage.setItem("uid", uid);
      if (docSnap.exists()) {
        setFirstnameByFunction(docSnap.data().firstname);
        window.sessionStorage.setItem("firstname", docSnap.data().firstname);

        setLastnameByFunction(docSnap.data().lastname);
        window.sessionStorage.setItem("lastname", docSnap.data().lastname);

        if (docSnap.data().block === true) {
          window.sessionStorage.setItem("block", true);
        }

        // setStripeUserId(docSnap.data().stripeId);
        // window.sessionStorage.setItem("stripeUserId", docSnap.data().stripeId);

        if (docSnap.data().phone) {
          setPhone(docSnap.data().phone);
          window.sessionStorage.setItem("phone", docSnap.data().phone);
        }
        if (docSnap.data().position) {
          window.sessionStorage.setItem("position", docSnap.data().position);
        }
      } else {
        console.log("No such document!");
      }

      navigate("/dashboard");
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
          setDBerror(t("pass_wrong"));
          break;
        case "auth/user-not-found":
          setDBerror(t("doesntexist"));
          break;
        case "auth/too-many-requests":
          setDBerror("Too many requests. Try again later.");
          break;
        case "auth/operation-not-allowed":
          setDBerror("Signing in with Email and Password is not enabled.");
          break;
        default:
          setDBerror("An error happened. Please try again.");
      }
    }
    setProcessing(false);
  };

  const getNaverToken = () => {
    if (!location.hash) return;
    return location.hash.split("=")[1].split("&")[0];
  };
  useEffect(() => {
    const token = getNaverToken();
    initializeNaverLogin(token);
  }, []);

  const initializeNaverLogin = (token) => {
    const naverLogin = new naver.LoginWithNaverId({
      clientId: "KWVpgJ5ZYEOugfR6qcqt",
      callbackUrl: "https://prism-a6a80.firebaseapp.com/login",
      isPopup: false, // popup 형식으로 띄울것인지 설정
      loginButton: { color: "white", type: 3, height: "47", width: "100%" }, //버튼의 스타일, 타입, 크기를 지정
    });
    // naverLogin.logout();
    naverLogin.init();
    console.log("token", token);

    naverLogin.getLoginStatus(async (status) => {
      if (status && token) {
        console.log("naver login 상태", naverLogin.user);
        const { id, email, gender, birthday, name } = naverLogin.user;

        submit({
          password: id.substring(0, 8),
          email: email,
        });
      }
    });
  };

  return (
    <>
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "#6573c3" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t("login")}
        </Typography>

        <Box noValidate sx={{ mt: 1 }}>
          <form
            onSubmit={handleSubmit((data) => {
              submit(data);
            })}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              label={t("email")}
              autoComplete="email"
              autoFocus
              variant="filled"
              // onKeyPress={(event) => handleKeyPress(event)}
              {...register("email", {
                required: "Email is required.",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Please put valid email address.",
                },
              })}
            />
            <TextField
              {...register("password", {
                required: "Password is required.",
                minLength: {
                  value: 6,
                  message: "Password's minimum length is 6.",
                },
              })}
              // onKeyPress={(event) => handleKeyPress(event)}
              margin="normal"
              required
              fullWidth
              name="password"
              autoFocus
              label={t("pass")}
              type={showPassword ? "text" : "password"}
              variant="filled"
              id="password"
              onChange={() => setDBerror(null)}
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    sx={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </InputAdornment>
                ),
              }}
            />
            {/* <FormControlLabel
						control={<Checkbox value="remember" color="primary" />}
						label="Remember me"
					/> */}

            <Box
              sx={{
                paddingTop: "10px",
                fontWeight: "bold",

                width: 1,
                fontSize: "13px",
                color: "#ff385c",
                position: "relative",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  top: "+3px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {errors.email && (
                  <Alert severity="warning">{errors.email?.message}</Alert>
                )}
                {!errors.email && errors.password && (
                  <Alert severity="warning">{errors.password?.message}</Alert>
                )}
                {!errors.email && !errors.password && DBerror && (
                  <Alert severity="warning">{DBerror}</Alert>
                )}
              </div>
            </Box>
            <Box sx={{ py: 3 }}>
              <button
                type="submit"
                className="custom_btn"
                disabled={processing}
                fullWidth
                sx={{
                  mt: 3,
                  mb: 2,
                  borderRadius: 0,
                }}
              >
                {processing ? "...Processing" : t("login")}
              </button>
            </Box>
          </form>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <div id="naverIdLogin" />
          </Box>
          <Grid container>
            <Grid item xs>
              <Link href="/forgot" variant="body2">
                {t("forgot")}
              </Link>
            </Grid>
            <Grid item>
              <Link href="/signup">{t("gotosignup")}</Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 10 }} />
    </>
  );
}
